export const toolbarGroup =
    '<div class="group">\n'
    + '    <div class="group-icon group-toolbar-button">'
    + '        <div class="icon"></div>'
    + "    </div>\n"
    + '    <div class="actions">\n'
    + "\n"
    + "    </div>\n"
    + '    <div class="title"></div>\n'
    + "</div>";
